import { SuperAgentError, SuperAgentStatic } from 'superagent';
import superagentAbsolute from 'superagent-absolute';
import superagentDefaults from 'superagent-defaults';
import { API_CALL, ApiStatusCode, IApiAction } from './types';

const TYPE = 'API';

export type CreateRequestOptions = {
  baseUrl?: string;
  omitBearerPrefix?: boolean;
  token?: string;
};

export function createApiAction<S extends string, M, A>(
  service: S,
  method: M,
  args?: A,
): IApiAction<S, M, A> {
  return {
    type: TYPE,
    [API_CALL]: { args, method, service },
  };
}

export function createRequest(opts?: CreateRequestOptions): SuperAgentStatic {
  const { baseUrl, omitBearerPrefix, token } = opts ?? {};

  const defaults = superagentDefaults();

  if (token) {
    defaults.set('Authorization', omitBearerPrefix ? token : `Bearer ${token}`);
  }

  return baseUrl ? superagentAbsolute(defaults)(baseUrl) : defaults;
}

function isSuperAgentError(error: unknown): error is SuperAgentError {
  return (
    typeof error === 'object' &&
    typeof (error as SuperAgentError).status === 'number'
  );
}

export function handleApiError(
  /**
   * The error can originate from various sources (e.g., SuperAgent, native exceptions,
   * rejected promises). Using the `unknown` type provides flexibility and ensures
   * proper type narrowing before accessing properties.
   */
  error: unknown,
  onInvalidToken: () => void,
): void {
  if (!error || !isSuperAgentError(error)) {
    return;
  }

  const statusCode = error?.response?.body?.status ?? error?.response.status;

  if (!statusCode) {
    return;
  }

  switch (statusCode) {
    case ApiStatusCode.UNAUTHORIZED:
      onInvalidToken();
      break;

    default:
      break;
  }
}
